/**
 * HostDashboardSwitcher (Iter 9.40 Pass K)
 * Pill list shown on /me when a user owns more than one host event (e.g. Shelsea
 * with both makeup primary + instructor secondary).
 */
import { useEffect, useState } from "react";
import { Sparkles, GraduationCap, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HostDashboardSwitcher() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("session_token");
    if (!token) return;
    fetch(`${API}/me/host-events`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : { host_events: [] }))
      .then((d) => setEvents(d.host_events || []))
      .catch(() => {});
  }, []);

  if (!events || events.length < 2) return null; // Only show when 2+ dashboards

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4" data-testid="host-dashboard-switcher">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-900">Your dashboards</h3>
        <span className="text-[10px] text-gray-500">{events.length} active</span>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        {events.map((e) => {
          const Icon = e.is_instructor ? GraduationCap : Sparkles;
          return (
            <a
              key={e.event_id}
              href={`/host/v2/${e.event_id}`}
              className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-black hover:bg-gray-50 transition-all"
              data-testid={`switcher-${e.event_id}`}
            >
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4 text-gray-700" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-900 truncate">{e.org_name || "Untitled"}</p>
                <p className="text-[11px] text-gray-500 capitalize">{e.category}{e.is_instructor ? " · instructor" : ""}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
            </a>
          );
        })}
      </div>
    </div>
  );
}
